import { Col, Form, Row, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { MdPassword } from 'react-icons/md'
import '../../assets/styles/scss/pages/_login.scss'
import ButtonUC from '../../components/buttonUC'
import InputUC from '../../components/Form/InputUC'
import OtpRemaining from './otp-remaining'
import OtpRemainingExpire from './otp-remaining-expire'
import axiosRc from '../../config/axios-rc'

const FormOtp = ({ props }) => {
    const {
        form,
        otpEmail,
        otpRefCode,
        onFinish,
        onResendOtp,
        setLoadingModal,
        setIsShowOtp } = props
    const [validOtp, setValidOtp] = useState(true)
    const [otpTimeUp, setOtpTimeUp] = useState(false)
    const [otpExpire, setOtpExpire] = useState(false)
    const [enableConfirm, setEnableConfirm] = useState(false)
    const [fullFilled, setFullFilled] = useState(false)
    const [startTimeRemaining, setStartTimeRemaining] = useState(60)
    const { Text } = Typography
    const otp1Watch = Form.useWatch('otp1', form);
    const otp2Watch = Form.useWatch('otp2', form);
    const otp3Watch = Form.useWatch('otp3', form);
    const otp4Watch = Form.useWatch('otp4', form);
    const otp5Watch = Form.useWatch('otp5', form);
    const otp6Watch = Form.useWatch('otp6', form);

    useEffect(() => {
        setLoadingModal(false)
        return () => {
            form.setFieldsValue({
                otp1: '',
                otp2: '',
                otp3: '',
                otp4: '',
                otp5: '',
                otp6: '',
            })
        }
    }, [])

    const handleConfirmOtp = async () => {
        if (otp1Watch && otp2Watch && otp3Watch && otp4Watch && otp5Watch && otp6Watch) {
            const _otp = otp1Watch + otp2Watch + otp3Watch + otp4Watch + otp5Watch + otp6Watch
            const params = `?email=${form.getFieldValue('email_login')}&otp=${_otp}`
            const { data: resOTP } = await axiosRc.get(`/jobList/validate_otp/${params}`);
            if (resOTP?.token) {
                localStorage.setItem('token', resOTP?.token)
                localStorage.setItem('refreshToken', resOTP?.refreshToken)
                onFinish()
            } else {
                setFullFilled(false)
                setValidOtp(false)
            }
        }
    }

    const onKeyDownOtp = (event, index) => {
        if (event.key !== 'Backspace') return

        event.preventDefault()
        form.setFieldsValue({ [`otp${index + 1}`]: '' })
        setEnableConfirm(false)
        setFullFilled(false)
        if (index > 0) {
            form.getFieldInstance(`otp${index}`).focus()
        }
    }

    const onKeyUpOtp = (e) => {
        if (e.key === 'Backspace') return

        try {
            if (/^[0-9]$/.test(e.target.value)) {
                if (otp1Watch && otp2Watch && otp3Watch && otp4Watch && otp5Watch && otp6Watch && !otpExpire) {
                    setEnableConfirm(true)
                    setFullFilled(true)
                } else {
                    setEnableConfirm(false)
                    setFullFilled(false)
                }
                const nextId = e.target.id.slice(-1)
                if (nextId < 6) {
                    const fieldRef = form.getFieldInstance(`otp${+nextId + 1}`);
                    fieldRef.focus();
                }
            } else { form.setFieldsValue({ [e.target.id]: null }) }

        } catch (err) {
            setValidOtp(false)
        }
    }

    const onFocus = (e) => {
        e.target.select()
    }

    const onPasteOtp = (event) => {
        event.preventDefault()
        const code = event.clipboardData.getData('text').trim()
        if (!/^[0-9]{6}$/.test(code)) return

        form.getFieldInstance('otp6').focus()
        form.setFieldsValue(Object.fromEntries(
            code.split('').map((digit, index) => [`otp${index + 1}`, digit])
        ))
        setValidOtp(true)
        setEnableConfirm(!otpExpire)
        setFullFilled(!otpExpire)
    }

    const handleResendOtp = (value) => {
        setIsShowOtp(false)
        setStartTimeRemaining(60)
        onResendOtp()
    }

    return (
        <div className='form-otp'>
            <div className="icon-login">
                <MdPassword />
            </div>

            <div className="title-login text-3xl text-center">เข้าสู่ระบบ / ลงทะเบียน</div>
            {validOtp && !otpTimeUp && <div className="title-login text-center">รหัสยืนยันตัวตนถูกส่งไปยังอีเมล</div>}
            {!validOtp && !otpTimeUp && <div className="title-login text-center color-error">รหัสยืนยันตัวตนไม่ถูกต้อง</div>}
            {otpExpire && <div className="title-login text-center color-error">OTP หมดอายุ กรุณากด ส่งอีกครั้ง</div>}
            <div className="title-login text-center">{form.getFieldValue('email_login')}</div>
            <Row className="py-2 row-otp-input">
                {Array(6).fill('').map((value, index) => (
                    <Col key={index} span={4} className='px-2'>
                        <InputUC
                            maxLength={1}
                            className={`mb-0 input-otp ${fullFilled ? ' filled-otp ' : ''} ${!validOtp && fullFilled === false ? ' invalid-otp ' : ''}`}
                            showLabel={false}
                            name={`otp${index + 1}`}
                            onKeyDown={event => onKeyDownOtp(event, index)}
                            onKeyUp={onKeyUpOtp}
                            onPaste={onPasteOtp}
                            onFocus={onFocus}
                            showPlaceholder={false} />
                    </Col>
                ))}
            </Row>
            <Row className="py-2 justify-center">
                {!otpExpire &&
                    <div className='flex flex-col'>
                        <div className="text-center ">{'OTP มีอายุ 5 นาที'}
                            <OtpRemainingExpire setOtpExpire={setOtpExpire} />
                        </div>
                        <div className="ref-code color-gray7">{'Ref. Code : ' + otpRefCode}</div>
                    </div>
                }
            </Row>
            <Row className="py-2 justify-center">
                {otpTimeUp === true && <Text className='cursor-pointer text-send-again' onClick={handleResendOtp}>ส่งอีกครั้ง</Text>}
                {otpTimeUp === false &&
                    <>
                        <div className="text-center text-remaiming">{'กรุณารอ '}
                            <OtpRemaining setOtpTimeUp={setOtpTimeUp} startTimeRemaining={startTimeRemaining} />{' เพื่อกดส่งอีกครั้ง'}
                        </div>
                    </>
                }
            </Row>
            <Row className="py-2 ">
                <Col span={24} className='px-2 text-center'>
                    <ButtonUC
                        style={{ width: '170px' }}
                        className='btn-custom'
                        disabled={enableConfirm === false || otpExpire}
                        onClick={enableConfirm && !otpExpire ? handleConfirmOtp : {}}
                    >{'ยืนยัน'}
                    </ButtonUC>
                </Col>
            </Row>
        </div>
    )
}

export default FormOtp
